import _BankIcon from './bankIcon/bankIcon.index';
import _Card from './card/card.index';
import _Loading from './loading/loading.index';

export { _BankIcon as BankIcon };
export { _Card as Card };
export { _Loading as Loading };
